<div
    class="welcome-system-settings"
    provideParentForm
>
    <backup-passphrase
        name="backupPassphrase"
        [(ngModel)]="backupConfig.backupPassphrase"
    ></backup-passphrase>
    <avi-input-container>
        <label
            aviLabelWithTooltip
            objectType="DNSConfiguration"
            fieldName="server_list"
            for="server_list"
        >
            {{ l10nKeys.dnsResolverLabel | vtranslate }}
        </label>
        <input
            id="server_list"
            class="sel-dns-address"
            name="server_list"
            [(ngModel)]="systemConfig.getDNSConfig().server_list"
            clrInput
            placeholder="000.000.000.000"
            parseIpList
        />
    </avi-input-container>
    <avi-input-container>
        <label
            aviLabelWithTooltip
            objectType="DNSConfiguration"
            fieldName="search_domain"
            for="search_domain"
        >
            {{ l10nKeys.dnsSearchDomainLabel | vtranslate }}
        </label>
        <input
            id="search_domain"
            class="sel-dns-search-domain"
            name="search_domain"
            [(ngModel)]="systemConfig.getDNSConfig().search_domain"
            clrInput
            placeholder="{{ l10nKeys.dnsSearchDomainFieldPlaceholder | vtranslate }}"
            regexPattern="listOfHostnamesWithSpaces"
        />
    </avi-input-container>
    <div class="welcome-system-settings__telemetry-message-header">
        {{ globalL10nKeys.telemetryMessageHeaderText | vtranslate }}
    </div>
    <div
        class="welcome-system-settings__telemetry-message-body"
        [innerHTML]="globalL10nKeys.telemetryMessageBodyText | vtranslate: ceipUrl"
    ></div>
    <clr-checkbox-container>
        <clr-checkbox-wrapper>
            <input
                clrCheckbox
                id="enable"
                name="enable"
                type="checkbox"
                [(ngModel)]="systemConfig.getTelemetryConfig().enable"
            />
            <label
                aviLabelWithTooltip
                [objectType]="telemetryObjectType"
                fieldName="enable"
                for="enable"
            >
                {{ globalL10nKeys.telemetryWelcomeInputLabel | vtranslate }}
            </label>
        </clr-checkbox-wrapper>
    </clr-checkbox-container>

    <div class="welcome-system-settings__user-settings">
        <h6>{{ l10nKeys.myAccountSettingsLabel | vtranslate }}</h6>
        <clr-checkbox-container>
            <clr-checkbox-wrapper>
                <input
                    clrCheckbox
                    id="enable-config-warnings"
                    name="enable-config-warnings"
                    type="checkbox"
                    [(ngModel)]="userAccount.enable_config_warnings"
                />
                <label
                    aviLabelWithTooltip
                    for="enable-config-warnings"
                >
                    {{ l10nKeys.enableConfigurationWarningsChecksLabel | vtranslate }}
                </label>
            </clr-checkbox-wrapper>
        </clr-checkbox-container>
    </div>
</div>
